<template>
  <div class="company-view layout-max-width">
    <heading :title="title" key="company-view-title">
      <b-button
          v-if="canEdit"
          class="mb-2 mb-lg-0"
          variant="primary"
          :to="`/rentalcompany/edit/${rentalCompanyId}`"
      >
        Edit Rental Company
        <b-icon-pencil-square />
      </b-button>
    </heading>
    <b-row>
      <b-col class="col-12 col-md-6 offset-md-3 text-center">
        <view-table class="company-table"
                    :model="rentalCompany"
                    :data="rentalCompanyInfo"
                    :fields="rentalCompanyFields">
          <template v-slot:address_1>
            {{ rentalCompanyInfo.address_1 }}
            <template v-if="rentalCompanyInfo.address_2">
              <br/>
              {{ rentalCompanyInfo.address_2 }}
            </template>
            <br/>
            {{ rentalCompanyInfo.city }}, {{ rentalCompanyInfo.state }} {{ rentalCompanyInfo.zip }}
          </template>
          <template v-slot:companyAdminUser="slotProps">
            <user-details :user="slotProps.value"/>
          </template>
        </view-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from "vue";
import RentalCompany from "@/models/RentalCompany";
import UserDetails from "@/components/UserDetails";
import * as _ from "lodash";
import Authorization from "@/providers/Authorization";

export default Vue.extend({
  name: "RentalCompanyView",
  components: {UserDetails},
  props: {
    rentalCompanyId: Number
  },
  data() {
    return {
      rentalCompanyInfo: {},
      rentalCompany: RentalCompany,
      rentalCompanyFields: ["name", "address_1", "phone", "email", "status"],
      canEdit: false,
    };
  },
  computed: {
    title() {
      return this.rentalCompanyInfo?.name ?? "Rental Company";
    }
  },
  methods: {
    getStatusLabel(value) {
      return RentalCompany.getStatusLabel(value);
    },
    getName(item) {
      return item ? item.name : "";
    },
    getNames(value) {
      return value
          ? _.truncate(_.map(value, el => this.getName(el)).join(", "))
          : null;
    },
  },
  created() {
    console.log("Rental Company View  rentalCompanyId=", this.rentalCompanyId);
    //const extraFields = ["companyAdminUser", "companyContacts"];
    this.$api.getItem(this, "rental-company", this.rentalCompanyId)
        //return await this.$api.getItems(this, 'company', filters, null, [])
        .then(data => {
          console.log("Rental Company View  data=", data);
          this.rentalCompanyInfo = data;
        });
    Authorization.can({
      action: "edit",
      model: "rental-company",
      arg: this.rentalCompanyId
    }).then(canEdit => (this.canEdit = canEdit));
  }
});
</script>

<style lang="scss">
.company-table {
  width: 100%;

  th,
  td {
    font-size: 18px;
  }
}

.company-view {
  .heading__buttons {
    display: flex;
    justify-content: space-between;
    @media (max-width: 767px) {
      flex-wrap: wrap;

      .btn {
        width: 46%;
      }
    }
  }

  .field-value__mailing_address {
    white-space: pre;
  }
}
</style>
